/* eslint-disable prefer-const */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, ContentChild, Input, TemplateRef, inject, OnInit } from '@angular/core';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { Router, Route, NavigationEnd, RouterModule } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { CommonModule } from '@angular/common';
import { filter } from 'rxjs';
import { TranslateModule, TranslateService } from '@ngx-translate/core'
import { Location } from '@angular/common';
import { SharedModule } from '../shared.module';
import { ButtonComponent } from './button.component';
import { ChipComponent } from "./chip.component";
import { Store } from '@ngrx/store';
import { selectAllAttestationCampaigns, selectAllEvaluationCampaigns } from '../../store/campaign-dashboard/campaign-dashboard.reducer';

@Component({
  selector: 'ui-ng-breadcrumb',
  standalone: true,
  imports: [BreadcrumbModule, CommonModule, SharedModule, TranslateModule, ButtonComponent, RouterModule, ChipComponent],
  providers: [],
  template: `
  <div class="flex justify-content-center align-items-center h-full max-h-4rem" style="{{'background:transparent;'+ style_a}}" >
    <div class="flex  align-items-center justify-content-between " [style]="'width:'+max_width"> 
      <div class="flex align-items-center  ">
        @if(!isHome()){
          <i (click)="goBack()" class="flex pi pi-arrow-left cursor-pointer" [class]="items.length === 1 && (items[0].label === 'Homepage' || items[0].label === 'home') ? 'opacity-60 pointer-events-none' : ''" style="color: #495057; margin-top: 2px" icon="" ></i>
        }
        <p-breadcrumb [styleClass]="" class="" [model]="items.length > 0 ? items : undefined" translate [home]="home"></p-breadcrumb>
    <!-- {{items | json }} -->
      </div>
      <div class="flex gap-3 align-items-center   max-h-4rem">
            <p style="color: var(--h1-color)!important;">{{ username }}   </p>     
            <div style="font-size: 10px;" class="border-round-xl  px-2 py-1">
              <ui-ng-chip [disable_hover]="true" [chips]="[{label:(role | translate), styleClass:'text-white border-primary bg-primary shadow-1 text-xs select-none '}]" style="font-size: 10px;"></ui-ng-chip>
            </div>
      </div>
      @if(buttonSection){
          <div class="flex w-full">
            <ng-container
              [ngTemplateOutlet]="buttonSection"
            >
            </ng-container>
          </div>
      }
    </div>
  </div>
  `,
  styles: [`
  ::ng-deep .p-breadcrumb { 
    padding-block: 0.5rem;
    background: none !important; 
    border:0px;
} 
::ng-deep .p-breadcrumb-list {
  gap: 0.3rem;
}
  `]
})
export class BreadcrumbComponent implements OnInit {
  @Input() items: MenuItem[] = [];
  @Input() home: MenuItem | undefined;
  @Input() max_width = '100%';
  @Input() style_a = '';
  router: Router = inject(Router);
  location: Location = inject(Location)
  translateService: TranslateService = inject(TranslateService);
  private store = inject(Store);
  private allAttestationCampaigns = this.store.selectSignal(selectAllAttestationCampaigns);
  private allEvaluationCampaigns = this.store.selectSignal(selectAllEvaluationCampaigns);
  url: string | undefined
  @Input() username = 'Mario rossi';
  @Input() role = 'End User';
  @ContentChild('buttonSection') buttonSection?: TemplateRef<any>

  constructor() {
    this.translateService.use('it')
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: any) => {
      this.items = [];
      try {
        this.generateBreadcrumb(event.url)
      } catch (error) {
        console.log('Error generating breadcrumb:', error);
      }
      return event['url']
    });
  }




  ngOnInit() {
    this.home = { icon: 'pi pi-home', routerLink: `/home` };
    // //console.logthis.location.path().split('/'));
    try {
      this.generateBreadcrumb(this.location.path())
    } catch (error) {
      console.log('Error generating breadcrumb:', error);
    }
  }

  goBack() {
    const currentUrl = this.location.path().split('/')
    currentUrl.pop();
    const redirectURL: string = currentUrl.join('/')
    this.router.navigateByUrl(redirectURL);

  }
  calcolaUrlPrecedente(url: string) {
    const segments = url.split('/');
    segments.pop();
    return segments.join('/')
  }

  isHome(): boolean {
    return this.router.url === '/' || this.router.url === '/home';
  }
  buildHistoryPathUntil(number: number) {
    // Get the current path and remove any query parameters
    const currentPath = this.location.path().split('?')[0];
    const paths = currentPath.split('/');

    let result = '';
    paths
      .filter((path, index) => index !== 0 && index <= number)
      .forEach(p => result += "/" + p);

    return result;
  }
  generateBreadcrumb(path: string) {
    // Remove query parameters from the path
    const pathWithoutQuery = path.split('?')[0];

    let items: any[] = [];
    pathWithoutQuery.split('/').forEach((parola: string, index: number) => {
      if (index !== 0) {
        // Try to get the breadcrumb label from the route data if available
        let label;

        try {
          // Check if we can find a route configuration for this path segment
          const routes = this.router.config;
          const pathSegments = pathWithoutQuery.split('/').filter(segment => segment);

          // Only attempt to get route data if we have enough path segments
          if (index <= pathSegments.length) {
            const currentRoute = this.findRouteByPath(routes, pathSegments.slice(0, index));
            if (currentRoute?.data?.breadcrumb) {
              label = currentRoute.data.breadcrumb;
            }
          }
        } catch (error) {
          console.log('Error finding route data:', error);
        }

        // If no label was found from route data, try to resolve ICS campaign ID
        if (!label) {
          label = this.resolveIcsCampaignLabel(parola, pathWithoutQuery) ?? this.checkParola(parola);
        }

        items.push({
          label: label,
          expanded: false,
          replaceUrl: true,
          styleClass: label.startsWith('Campaign') ? 'pointer-events-none' : 'hover:underline cursor-pointer',
          routerLink: this.buildHistoryPathUntil(index)
        });
      }
    });
    this.items = items;

    if (this.items[1]?.routerLink === "/administration/planner") {
      this.items.splice(1, 1)
    }
  }

  // Helper method to find a route by path segments
  private findRouteByPath(routes: any[], pathSegments: string[]): any {
    if (!pathSegments || pathSegments.length === 0) {
      return null;
    }

    // Join the path segments to create the current path to match
    const currentPath = pathSegments.join('/');

    // Try to find a route that matches the current path
    for (const route of routes) {
      if (route.path === currentPath) {
        return route;
      }

      // If this route has children, search them too
      if (route.children) {
        const childRoute = this.findRouteByPath(route.children, pathSegments.slice(1));
        if (childRoute) {
          return childRoute;
        }
      }
    }

    return null;
  }
  private resolveIcsCampaignLabel(segment: string, fullPath: string): string | null {
    if (!/^\d+$/.test(segment)) return null;
    const pathLower = fullPath.toLowerCase();
    if (!pathLower.includes('/ics/evaluation/') && !pathLower.includes('/ics/attestation/') && !pathLower.includes('/ics/attestation-questionnaire/')) return null;
    const allCampaigns = [...(this.allAttestationCampaigns() ?? []), ...(this.allEvaluationCampaigns() ?? [])];
    const campaign = allCampaigns.find(c => c.id === segment);
    if (!campaign?.year) return null;
    return campaign.period ? `${campaign.year} - ${campaign.period}` : `${campaign.year}`;
  }

  checkParola(parola: string) {
    // Special case for attestation-questionnaire
    if (parola.toLowerCase() === 'attestation-questionnaire') {
      return this.translateService.instant('ATTESTATION QUESTIONNAIRE');
    }

    // Check if it's a campaign or default formatting
    return this.translateService.instant(
      parola.split('-')[0].toLowerCase() === 'campaign'
        ? 'Campaign'
        : (parola !== '' ? parola.toUpperCase() : 'HOME'),
      { year: parola.split('-')?.[1] }
    );
  }



}
